import { Head } from "@/components/base/Head";
import { Breadcrumb } from "@/components/base/Breadcrumb";
import React from "react";
import Image from "next/image";

const ManagementDesignSheetPage = () => {
  const META_TITLE = "オンライン経営相談";
  const breadcrumbs = [
    {
      title: META_TITLE,
    },
  ];

  const sections = [
    {
      image: "management_design_sheet_section_1.png",
      title: "質問に答える",
      description:
        "中小企業のことを徹底的に考えた質問を複数用意致しました。会社の状況と向き合いながら質問に答えてみてください。",
    },
    {
      image: "management_design_sheet_section_2.png",
      title: "プレビューを確認",
      description: "~~~",
    },
    {
      image: "management_design_sheet_section_1.png",
      title: "専門家に質問",
      description:
        "中小企業のことを徹底的に考えた質問を複数用意致しました。会社の状況と向き合いながら質問に答えてみてください。",
    },
  ];

  return (
    <>
      <Head title={META_TITLE} canonicalPath={`/plans`} />
      <main className={"pb-20"}>
        <div className={"bg-blue-700 text-center leading-0"}>
          <div className={"hidden md:block"}>
            <Image
              src={"/images/index/online_consultation_kv.png"}
              width={1280}
              height={441}
              className={"m-auto"}
              alt={""}
            />
          </div>
          <div className={"md:hidden"}>
            <Image
              src={"/images/index/online_consultation_kv.sp.png"}
              width={375}
              height={350}
              alt={""}
            />
          </div>
        </div>
        <section className={"mt-10 mb-20 text-center"}>
          <p className={"text-xl md:text-4xl"}>2022年2月上旬公開予定</p>
        </section>
        <div className={"max-w-[1440px] m-auto px-4 py-2"}>
          <Breadcrumb breadcrumbs={breadcrumbs} />
        </div>
      </main>
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {},
  };
}
export default ManagementDesignSheetPage;
